/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Readiness_LeadInputs */

const en_us2_workout_readiness_lead = /** @type {(inputs: Workout_Readiness_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Two quick answers adjust only today's workout. Your plan stays the same.`)
};

const pt_br2_workout_readiness_lead = /** @type {(inputs: Workout_Readiness_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duas respostas rápidas ajustam só o treino de hoje. Seu plano continua igual.`)
};

const es_419_workout_readiness_lead = /** @type {(inputs: Workout_Readiness_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dos respuestas rápidas ajustan solo el entrenamiento de hoy. Tu plan sigue igual.`)
};

const pt_pt2_workout_readiness_lead = /** @type {(inputs: Workout_Readiness_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duas respostas rápidas ajustam só o treino de hoje. O teu plano fica igual.`)
};

const fr_fr2_workout_readiness_lead = /** @type {(inputs: Workout_Readiness_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deux réponses rapides ajustent seulement la séance du jour. Ton programme ne change pas.`)
};

const de_de2_workout_readiness_lead = /** @type {(inputs: Workout_Readiness_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zwei kurze Antworten passen nur das heutige Training an. Dein Plan bleibt gleich.`)
};

const it_it2_workout_readiness_lead = /** @type {(inputs: Workout_Readiness_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Due risposte veloci regolano solo l'allenamento di oggi. La tua scheda resta uguale.`)
};

/**
* | output |
* | --- |
* | "Two quick answers adjust only today's workout. Your plan stays the same." |
*
* @param {Workout_Readiness_LeadInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_readiness_lead = /** @type {((inputs?: Workout_Readiness_LeadInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Readiness_LeadInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_readiness_lead(inputs)
	if (locale === "es-419") return es_419_workout_readiness_lead(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_readiness_lead(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_readiness_lead(inputs)
	if (locale === "de-DE") return de_de2_workout_readiness_lead(inputs)
	if (locale === "it-IT") return it_it2_workout_readiness_lead(inputs)
	return en_us2_workout_readiness_lead(inputs)
});
export { workout_readiness_lead as "workout.readiness_lead" }